import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import './plugins/axios';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import dateFilter from '@/filters/date.filter';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'devexpress-diagram/dist/dx-diagram.css';
import './scss/common.scss';
import i18n from "./i18n";
import axios from "axios";
import Main from "./Main.vue";

import enMessages from "devextreme/localization/messages/en.json";
import deMessages from "devextreme/localization/messages/de.json";
import ruMessages from "devextreme/localization/messages/ru.json";
import huMessages from "devextreme/localization/messages/hu.json";
//import roMessages from "devextreme/localization/messages/ro.json";
//import srMessages from "devextreme/localization/messages/sr.json";
import { locale, loadMessages } from "devextreme/localization";
import config from "devextreme/core/config";

window.locale = locale;
config({
    forceIsoDateParsing: true
})

Vue.config.productionTip = false;
Vue.filter('date', dateFilter);

axios.interceptors.request.use(
    config => {
      const accessToken = (store.state).accessToken;
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }

      return config;
    },

    error => {
      return Promise.reject(error);
    }
);

export default new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: (h) => h(Main),
    created: function () {
        loadMessages(enMessages);
        loadMessages(deMessages);
        loadMessages(ruMessages);
        loadMessages(huMessages);
        locale(navigator.language);
    }
}).$mount('#app');
